import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CallToAction = () => {
  const contactMethods = [
    {
      icon: "Mail",
      title: "Email Me",
      description: "fawasbello9@gmail.com",
      action: "mailto:fawasbello9@gmail.com"
    },
    {
      icon: "Phone",
      title: "Call Me",
      description: "+234 (091) 3760-9550",
      action: "tel:+2349137609550"
    },
    {
      icon: "MessageCircle",
      title: "Let\'s Chat",
      description: "Schedule a meeting",
      action: "#"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary to-accent text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-48 h-48 border border-white rounded-full"></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 border border-white rounded-full"></div>
      </div>
      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Start Your Next Project?
          </h2>
          <p className="text-lg opacity-90 max-w-2xl mx-auto">
            Let's collaborate and bring your ideas to life. I'm always excited to work on challenging projects and help businesses achieve their digital goals.
          </p>
        </div>

        {/* Main CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <Link to="/contact-form">
            <Button 
              variant="secondary"
              size="lg"
              iconName="Send"
              iconPosition="left"
              className="w-full sm:w-auto bg-white text-primary hover:bg-gray-50"
            >
              Start a Project
            </Button>
          </Link>
          
          <Link to="/portfolio-projects">
            <Button 
              variant="outline"
              size="lg"
              iconName="Eye"
              iconPosition="left"
              className="w-full sm:w-auto border-white text-white hover:bg-white hover:text-primary"
            >
              View My Work
            </Button>
          </Link>
        </div>

        {/* Contact Methods */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {contactMethods?.map((method, index) => (
            <div 
              key={index}
              className="text-center group cursor-pointer"
              onClick={() => method?.action?.startsWith('http') || method?.action?.startsWith('mailto') || method?.action?.startsWith('tel') ? window.open(method?.action) : null}
            >
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-white/30 transition-colors duration-200">
                <Icon name={method?.icon} size={24} className="text-white" />
              </div>
              <h3 className="text-lg font-semibold mb-2">{method?.title}</h3>
              <p className="opacity-90">{method?.description}</p>
            </div>
          ))}
        </div>

        {/* Social Proof */}
        <div className="text-center">
          <p className="text-sm opacity-80 mb-4">Trusted by developers and businesses worldwide</p>
          <div className="flex justify-center items-center space-x-8 opacity-60">
            <div className="flex items-center space-x-2">
              <Icon name="Star" size={16} className="text-yellow-300" />
              <span className="text-sm">4.9/5 Rating</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Users" size={16} />
              <span className="text-sm">30+ Happy Clients</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircle" size={16} className="text-green-300" />
              <span className="text-sm">100% Success Rate</span>
            </div>
          </div>
        </div>

        {/* Availability Status */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center px-4 py-2 bg-green-500/20 rounded-full">
            <div className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></div>
            <span className="text-sm font-medium">Available for new projects</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;